import { FC } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";

/**
 * 1NOW-11132: what a vehicle grid shows when the filters leave nothing. Without
 * it the renter saw an empty grid and could not tell a broken page from "no
 * match", with no way back but reopening each filter.
 */
const NoVehiclesMatch: FC<{ onClear: () => void }> = ({ onClear }) => (
  <div
    role="status"
    className="col-span-full flex w-full flex-col items-center justify-center rounded-xl border border-secondary-100 px-6 py-14 text-center"
  >
    <p className="text-lg font-semibold text-text-color">
      No vehicles match your filters
    </p>
    <p className="mt-2 max-w-sm text-sm text-text-color opacity-80">
      Clear a filter to see the rest of the fleet.
    </p>
    <ButtonPrimary type="button" className="mt-6 rounded-md" onClick={onClear}>
      Clear filters
    </ButtonPrimary>
  </div>
);

export default NoVehiclesMatch;
